import List from 'containers/CentreServices/List';
import Edit from 'containers/CentreServices/Edit';
import Create from 'containers/CentreServices/Create';
import Show from 'containers/CentreServices/Show';

export default { List, Edit, Create, Show };
